import api from './api';

export const authService = {
  // Send verification code for registration
  sendVerificationCode: async (email) => {
    const response = await api.post('/send-verification-code', { email });
    return response.data;
  },

  // Register new user
  register: async (userData) => {
    const response = await api.post('/register', userData);
    if (response.data.token) {
      sessionStorage.setItem('token', response.data.token);
    }
    return response.data;
  },

  // Login user
  login: async (email, password) => {
    try {
      console.log('[Auth Service] Attempting login for:', email);
      const response = await api.post('/login', { email, password });
      console.log('[Auth Service] Login response:', response.data);
      if (response.data.token) {
        sessionStorage.setItem('token', response.data.token);
        console.log('[Auth Service] Token saved to sessionStorage');
      } else {
        console.warn('[Auth Service] No token in response:', response.data);
      }
      return response.data;
    } catch (error) {
      // Re-throw with more context
      console.error('[Auth Service] Login API error:', error);
      console.error('[Auth Service] Error details:', {
        message: error.message,
        code: error.code,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url,
        baseURL: error.config?.baseURL,
      });
      throw error;
    }
  },

  // Logout user
  logout: async () => {
    try {
      await api.post('/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      sessionStorage.removeItem('token');
    }
  },

  // Get current authenticated user
  getCurrentUser: async () => {
    const response = await api.get('/me');
    return response.data;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!sessionStorage.getItem('token');
  },

  // Get token
  getToken: () => {
    return sessionStorage.getItem('token');
  },

  // Update profile
  updateProfile: async (profileData) => {
    const response = await api.put('/profile', profileData);
    return response.data;
  },

  // Add phone for legacy accounts (after login)
  addPhone: async (phone) => {
    const response = await api.post('/auth/add-phone', { phone });
    return response.data;
  },

  // Change password
  changePassword: async (currentPassword, newPassword, confirmPassword) => {
    const response = await api.post('/change-password', {
      current_password: currentPassword,
      password: newPassword,
      password_confirmation: confirmPassword,
    });
    return response.data;
  },
};
